export default '4.16.2';


//////////////////
// WEBPACK FOOTER
// ../node_modules/antd/es/version/version.js
// module id = 3187
// module chunks = 0